import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';
import { Project } from '@src/app/models/project';
import { Projecttemplate } from '../model/projecttemplate';
import { Organization } from '@src/app/models/organization';
import { Customerdeal } from '@src/app/models/customerdeal';

@Injectable({
  providedIn: 'root'
})
export class ProjecttemplatelistService {

  constructor(private http:HttpClient) { }

  getProjectTemplates(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	/organization/{organizationId}/template/list
    return this.http.get<Projecttemplate[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/template/list',httpOptions)
  
  }
  // getCustomers(){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   ///organization/{organizationId}/customer/list/pit/{pitdate}
  //   return this.http.get<Customer[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/customer/list/pit/"+ new Date().toISOString(),httpOptions);
  // }
  createProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project',project,httpOptions)
  }
  getOrg(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    ///organization/{organizationId}
    return this.http.get<Organization>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg(),httpOptions);
  }
  //get deals for customer
  getDeals(customerId,pit){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	    /organization/{organizationId}/customer/{customerId}/deal/list/pit/{pitdate}
    return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/list/pit/'+pit,httpOptions);
 
  }
}
